import { FC } from 'react'
import { PoiLayer } from './PoiLayer.tsx'
import { Poi } from '../../../../types'

type PoisProps = {
    pois: Array<Poi>
}

export const PoiLayers: FC<PoisProps> = ({ pois }) => {
    return pois.map((poi) => {
        return <PoiLayer key={poi.id} poi={poi} />
    })
}
